import { useState } from "react";
import { useFormContext } from "react-hook-form";
import cep from "cep-promise";
import FormInput from "../../Elements/FormInput";
import { ICreditPaymentoForm } from "../../../types/forms";
import { cepMask } from "../../../utils/formMasks";
import states from "../../../utils/states";
import { IUserData } from "../../../providers/user/types";

interface BillingAddressSectionProps {
  userData: IUserData; // Substitua pelo tipo correto do userData
}

const BillingAddressSection = ({ userData }: BillingAddressSectionProps) => {
  const { 
    register, 
    setValue, 
    setFocus, 
    formState: { errors } 
  } = useFormContext<ICreditPaymentoForm>();

  const [cepValue, setCepValue] = useState(userData?.addressCEP);

  const checkCep = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    try {
      const cepResponse = await cep(cepValue);

      setValue("addressRoad", cepResponse.street);
      setValue("addressDistrict", cepResponse.neighborhood);
      setValue("addressCity", cepResponse.city);
      setValue("addressState", cepResponse.state);
      setFocus("addressNumber");
    } catch (error) {
      console.error(error);
      setFocus("addressCep");
    }
  };

  const handleCepInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    setCepValue(inputValue);
    setValue("addressCep", cepMask(inputValue));
  };

  return (
    <>
      <h5 className="m-0">
        Endereço da fatura
      </h5>
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="row g-3 align-items-center">
            <div className="col-12 col-md-4">
              <div className="form-floating">
                <FormInput
                  register={register}
                  error={errors.addressCep?.message}
                  onChange={handleCepInput}
                  name="addressCep"
                  type="text"
                  id="txtCep"
                  placeholder="Consulte pelo CEP:"
                />
              </div>
            </div>
            <div className="col-12 col-md-8">
              <div className="text-center text-md-start">
                <button className="btn btn-dark me-3" onClick={checkCep}>
                  Consultar
                </button>
                <a
                  href="http://www.buscacep.correios.com.br/sistemas/buscacep/"
                  className="btn btn-outline-dark"
                  target="_blank"
                  rel="noreferrer"
                >
                  Não sei meu CEP!
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-8">
          <div className="form-floating">
            <FormInput
              register={register}
              error={errors.addressRoad?.message}
              name="addressRoad"
              type="text"
              id="txtEndereco"
              placeholder="Endereço:"
            />
          </div>
        </div>
        <div className="col-sm-4">
          <div className="form-floating">
            <FormInput
              register={register}
              error={errors.addressNumber?.message}
              name="addressNumber"
              type="text"
              id="txtNumero"
              placeholder="Número:"
            />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-floating">
            <FormInput
              register={register}
              error={errors.addressComplement?.message}
              name="addressComplement"
              type="text"
              id="txtComplemento"
              placeholder="Complemento:"
            />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-floating">
            <FormInput
              register={register}
              error={errors.addressDistrict?.message}
              name="addressDistrict"
              type="text"
              id="txtBairro"
              placeholder="Bairro:"
            />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-floating">
            <FormInput
              register={register}
              error={errors.addressCity?.message}
              name="addressCity"
              type="text"
              id="txtCidade"
              placeholder="Cidade:"
            />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-floating">
            <select
              defaultValue="selecione"
              {...register("addressState")}
              className={`form-select ${!!errors.addressState && "border"}`}
              name="addressState"
              placeholder="Estado:"
              id="ddlEstado"
            >
              <option value="selecione" disabled>
                Selecione
              </option>
              {states.map((elm, i) => (
                <option key={i} value={elm.code}>
                  {elm.code}
                </option>
              ))}
            </select>
            <label className="label" htmlFor="ddlEstado">
              Estado
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default BillingAddressSection;